
<template>
        <v-btn :loading="loading" :disabled="loading" :href="link" target="_blank" text color="primary" class="mr-2">
            <v-icon small class="ml-2">mdi-download</v-icon>
            Baixar

          </v-btn>
</template>
<script>
import { BASE_URL } from '@/http'
import axios from 'axios'
export default {
    name: 'SecureDownload',
    data: () => ({
        link: null,
        loading: true
    }),
    props: {
        src: String  
    },
    mounted(){
        this.loading = true
        //const prefix = this.$sandbox ? 'http://canaldoanuncio.test/api/v1/' : 'https://app.canaldoanuncio.com/api/v1/'
        this.$axios.get(`${BASE_URL}/security/open/link?region=sa-east-1&url=${this.src}&src=${this.src}`).then((res) => {
        this.link =  res.data.data
        this.$emit('update-secure-link', this.link)
        this.loading = false
      })
    }
}
</script>